"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

export const SectionComponent: RegisteredComponent = {
  name: "Core:Section",
  override: true,
  component: dynamic(async () => (await import("./Section")).Section),
  canHaveChildren: true,
  inputs: [
    {
      name: "children",
      type: "uiBlocks",
      defaultValue: [],
      hideFromUI: true,
    },
    {
      name: "enableSuspense",
      type: "boolean",
      defaultValue: false,
      friendlyName: "Lazy load section content",
      helperText: "When enabled, section content loads progressively to improve page speed.",
    },
  ],
};
